import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  FetchSponsorProducts,
  DeleteSponsorApi,
  FetchAdminSponsorProducts,
} from "../../ApiCalls/AddProducts";
import { BASE_URL } from "../../constant/api";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { toast, ToastContainer } from "react-toastify";

const AdminSponsorView = () => {
  const { sponsorId } = useParams();
  const [sponsor, setSponsor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedSponsor, setSelectedSponsor] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSponsor = async () => {
      setLoading(true);
      try {
        const response = await FetchAdminSponsorProducts(sponsorId);
        setSponsor(response);
        console.log(response);
        
        setError(null);
      } catch (err) {
        console.error("Error fetching sponsor details:", err);
        setError("Failed to load sponsor details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchSponsor();
  }, [sponsorId]);

  const handleDelete = async () => {
    if (selectedSponsor) {
      try {
        await DeleteSponsorApi(selectedSponsor.sponsored.id);
        setShowConfirm(false);
        setSelectedSponsor(null);
        toast.success("Sponsor deleted successfully!");
        navigate("/admin/approval/sponsor");
      } catch (error) {
        console.error("Error deleting sponsor:", error);
        setShowConfirm(false);
        toast.error("Error deleting sponsor!");
      }
    }
  };

  return (
    <div>
      <ToastContainer position="top-center" autoClose={3000} />
      <h1 className="text-cen text-2xl font-medium text-green-600">
        Admin Sponsor View
      </h1>
      <div className="container mx-auto px-4 py-6">
        {loading ? (
          <p className="text-center text-gray-600">
            Loading sponsor details...
          </p>
        ) : error ? (
          <p className="text-center text-red-500">{error}</p>
        ) : sponsor ? (
          <div>
            <div className="mb-6 flex w-full gap-10">
              <div className="h-44 w-1/2 overflow-hidden rounded-lg bg-slate-100 shadow-md">
                {sponsor.sponsored.sponsored_banner ? (
                  <img
                    src={`${BASE_URL}${sponsor.sponsored.sponsored_banner}`}
                    alt="Sponsor Banner"
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <div className="flex h-full items-center justify-center bg-gray-200 text-gray-500">
                    No Banner Available
                  </div>
                )}
              </div>

              <div className="flex flex-1 flex-col space-y-4">
                <div className="flex w-1/3 flex-col space-y-1">
                  <label className="text-base font-medium text-brand-primary">
                    Title
                  </label>
                  <p className="rounded-lg border border-black p-2">
                    {sponsor.sponsored.title}
                  </p>
                </div>

                <div className="flex gap-4">
                  <div className="flex flex-col space-y-1">
                    <label className="text-base font-medium text-brand-primary">
                      Start Date
                    </label>
                    <p className="rounded-lg border border-black p-2">
                      {sponsor.sponsored.start_date}
                    </p>
                  </div>

                  <div className="flex flex-col space-y-1">
                    <label className="text-base font-medium text-brand-primary">
                      End Date
                    </label>
                    <p className="rounded-lg border border-black p-2">
                      {sponsor.sponsored.end_date}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="grid min-w-[800px] grid-cols-[4rem,2fr,2fr,2fr,1fr,1fr,1fr] font-medium text-brand-button-green-bg">
                <div className="text-center">Item No</div>
                <div className="text-center">Product Code</div>
                <div className="text-center">Product Name</div>
                <div className="text-center">Stock</div>
                {/* <div className="text-center">Discount</div> */}
                <div className="text-center">Price</div>
              </div>
              {sponsor.products && sponsor.products.length > 0 ? (
                sponsor.products.map((product, index) => (
                  <div
                    key={product.id}
                    className="grid min-w-[800px] grid-cols-[4rem,2fr,2fr,2fr,1fr,1fr,1fr] items-center gap-2 py-2 text-[#2F2E41]"
                  >
                    <div className="rounded-xl border p-2 text-center">
                      {index + 1}
                    </div>
                    <div className="rounded-xl border p-2 text-center">
                      {product.product_code}
                    </div>
                    <div className="rounded-xl border p-2 text-center">
                      {product.product_name}
                    </div>
                    <div className="rounded-xl border p-2 text-center">
                      {product.stock}
                    </div>
                    {/* <div className="rounded-xl border p-2 text-center">
                      {product.discount}%
                    </div> */}
                    <div className="rounded-xl border p-2 text-center">
                      ${product.price}
                    </div>
                    
                    <Link to={`/admin/product-details/${product.id}`}>
                      <div className="flex flex-1 items-center justify-center rounded-lg border border-green-600 py-2 text-center text-xs font-medium text-green-600 shadow-md transition hover:border-green-700 hover:bg-green-700 hover:text-white sm:text-sm">
                        View
                      </div>
                    </Link>
                  </div>
                ))
              ) : (
                <p className="py-4 text-center text-gray-500">
                  No products sponsored yet
                </p>
              )}
            </div>
          </div>
        ) : (
          <p className="text-center text-gray-600">No sponsor details found.</p>
        )}
      </div>
    </div>
  );
};

export default AdminSponsorView;
